module.exports = __webpack_public_path__ + "static/media/grid.739fcbce.svg";